// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__3ETcO","copy":"copy__1S_Aq","sideRight":"sideRight__3G5eH"};


//////////////////
// WEBPACK FOOTER
// ./components/TextWrapper/style.css
// module id = 6JeW
// module chunks = 0